<div class="application-permission-settings">
  <div class="page-header">
    <h3 class="page-title">Application Permissions</h3>
    <div class="page-subtitle">Application warnings and the LM Credit users granted each permission. Changes save right away.</div>
  </div>

  <div *ngIf="isLoading" class="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="settings-grid" [hidden]="isLoading">
    <!-- Stale data warning: global switches -->
    <mat-card class="content-card setting-card">
      <div class="setting-header">
        <div class="setting-icon"><mat-icon>sync_problem</mat-icon></div>
        <div class="setting-heading">
          <div class="setting-title">
            Stale Data Warning
            <mat-spinner *ngIf="isSaving('staleData')" diameter="14"></mat-spinner>
          </div>
          <div class="setting-hint">Warn when an application is outdated since it was opened. Applies to all users.</div>
        </div>
      </div>

      <div class="setting-body">
        <div class="option-row" *ngFor="let option of staleDataOptions">
          <div>
            <div class="option-label">{{ option.label }}</div>
            <div class="option-hint">{{ option.hint }}</div>
          </div>
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="staleDataNotification[option.key]"
            (change)="saveStaleDataNotification()"
            [attr.aria-label]="option.label">
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card>    

    <!-- User permissions: on/off switch plus who is granted -->
    <mat-card
      *ngFor="let permission of permissions"
      class="content-card setting-card"
      [class.is-off]="!enabled[permission.key]">
      <div class="setting-header">
        <div class="setting-icon"><mat-icon>{{ permission.icon }}</mat-icon></div>
        <div class="setting-heading">
          <div class="setting-title">
            {{ permission.label }}
            <mat-spinner *ngIf="isSaving(permission.key)" diameter="14"></mat-spinner>
          </div>
          <div class="setting-hint">{{ permission.hint }}</div>
        </div>
        <mat-slide-toggle
          color="primary"
          [(ngModel)]="enabled[permission.key]"
          (change)="savePermission(permission.key)"
          [attr.aria-label]="'Enable ' + permission.label">
        </mat-slide-toggle>
      </div>

      <div class="setting-body">
        <div class="granted-label">
          <ng-container *ngIf="enabled[permission.key]; else offLabel">
            Granted to {{ selected[permission.key].length }}
            {{ selected[permission.key].length === 1 ? 'user' : 'users' }}
          </ng-container>
          <ng-template #offLabel>
            <mat-icon class="off-icon">block</mat-icon>{{ permission.disabledHint }}
          </ng-template>
        </div>

        <app-user-picker
          [users]="users"
          [ngModel]="selected[permission.key]"
          (ngModelChange)="onUsersChange(permission.key, $event)"
          [disabled]="!enabled[permission.key]"
          disabledPlaceholder="Enable to add or remove users"
          [ariaLabel]="permission.label + ' users'">
        </app-user-picker>
      </div>
    </mat-card>

    <!-- Co-applicant remove/restore: global switches -->
    <mat-card class="content-card setting-card">
      <div class="setting-header">
        <div class="setting-icon"><mat-icon>group_remove</mat-icon></div>
        <div class="setting-heading">
          <div class="setting-title">
            Co-Applicant Remove / Restore
            <mat-spinner *ngIf="isSaving('coApplicant')" diameter="14"></mat-spinner>
          </div>
          <div class="setting-hint">Co-applicant actions in Details. Applies to all users.</div>
        </div>
      </div>

      <div class="setting-body">
        <div class="option-row" *ngFor="let option of coApplicantOptions">
          <div>
            <div class="option-label">{{ option.label }}</div>
            <div class="option-hint">{{ option.hint }}</div>
          </div>
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="coApplicantRemoveRestore[option.key]"
            (change)="saveCoApplicantRemoveRestore()"
            [attr.aria-label]="option.label">
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card>
  </div>
</div>
